/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon16Regular = forwardRef('ArrowCDownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.97 5.47a.75.75 0 0 1 1.06 0l3.793 3.793a.25.25 0 0 0 .354 0L11.97 5.47a.75.75 0 1 1 1.06 1.06l-3.793 3.793a1.75 1.75 0 0 1-2.474 0L2.97 6.53a.75.75 0 0 1 0-1.06Z" })));
});
